<p>Use to display prominent tile content with different variants, sizes, and optional icons.</p>

<h2>Use When</h2>
<ul>
  <li>Showing short semantic labels such as statuses, updates, or alerts</li>
  <li>Highlighting important information in dashboards and overview pages</li>
  <li>Presenting compact content in a visually prominent tile layout</li>
</ul>

<h2>Behavior</h2>
<ul>
  <li>Supports multiple tile variants: default, success, info, warning, error</li>
  <li>Supports multiple sizes: small, medium, large (default is medium)</li>
  <li>Allows an optional Material icon</li>
  <li>Supports icon placement at the start or end of the label</li>
  <li>Wraps longer labels to preserve layout in smaller containers</li>
</ul>

<p>
  Import the
  <app-text-code>TileComponent</app-text-code>
  and use it via
  <app-text-code>&lt;mad-tile&gt;</app-text-code>
  .
</p>

<p>Basic usage with optional values</p>
<example-viewer [example]="tilesComponent"></example-viewer>

<h2>API Specification</h2>
<app-tile-demo-api-spec></app-tile-demo-api-spec>
